// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_xlsx_dist_xlsx_mini_min_js":"b34f55507d5e43c3","node_modules_xlsx_xlsx_mjs":"a3b7692bc799e620"}[chunkId] + ".js";
};